import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-id", "onDragstart"]
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = {
  key: 0,
  class: "col-12"
}
const _hoisted_5 = { class: "row" }
const _hoisted_6 = {
  class: "col-11 m-0",
  style: {"padding-left":"17px","font-weight":"600"}
}
const _hoisted_7 = {
  key: 1,
  class: "col-12"
}
const _hoisted_8 = { class: "row" }
const _hoisted_9 = {
  class: "col-11 m-0",
  style: {"padding-left":"17px","font-weight":"600"}
}
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = { class: "row align-items-center" }
const _hoisted_12 = {
  key: 0,
  class: "col-1 pe-0 text-right",
  style: {"margin-bottom":"0.625rem"}
}
const _hoisted_13 = {
  key: 1,
  class: "col-1 pe-0 text-right",
  style: {"margin-bottom":"0.625rem"}
}
const _hoisted_14 = {
  key: 2,
  class: "col-1",
  style: {"height":"74px"}
}
const _hoisted_15 = { class: "col-11 m-0" }
const _hoisted_16 = {
  key: 0,
  class: "row"
}
const _hoisted_17 = { class: "col-12" }
const _hoisted_18 = { class: "row align-items-center" }
const _hoisted_19 = {
  class: "col-11",
  style: {"margin-top":"-7px"}
}
const _hoisted_20 = { class: "add-route-label" }
const _hoisted_21 = { class: "d-flex flex-column m-0" }
const _hoisted_22 = {
  key: 0,
  class: "custom-route-error-color font-small"
}
const _hoisted_23 = {
  key: 1,
  class: "custom-route-error-color font-small"
}
const _hoisted_24 = { class: "row" }
const _hoisted_25 = {
  key: 0,
  class: "custom-route-error-color font-small"
}
const _hoisted_26 = {
  class: "col-11 m-0 position-relative input-col-10-padding",
  "data-bs-toggle": 'modal',
  "data-bs-target": '#selectVehicleModal'
}
const _hoisted_27 = ["placeholder", "value"]
const _hoisted_28 = { class: "d-flex flex-column m-0" }
const _hoisted_29 = {
  key: 0,
  class: "custom-route-error-color font-small"
}
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-11 input-col-10-padding" }
const _hoisted_32 = { class: "d-flex flex-column m-0" }
const _hoisted_33 = {
  key: 0,
  class: "custom-route-error-color font-small"
}
const _hoisted_34 = { class: "font-small error-color custom-route-error-color" }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "col-11 input-col-10-padding" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomRouteAddressSelectComponent = _resolveComponent("CustomRouteAddressSelectComponent")!
  const _component_OptionSelectComponent = _resolveComponent("OptionSelectComponent")!
  const _component_CalendarComponent = _resolveComponent("CalendarComponent")!
  const _component_CustomRoutePriceWrapperComponent = _resolveComponent("CustomRoutePriceWrapperComponent")!
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.store.state.orderTrueDriver.customRoutes, (route, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "row drag-el drop-zone",
        key: route.id,
        "data-id": index,
        draggable: "true",
        onDragstart: ($event: any) => (_ctx.startDrag($event, _ctx.store.state.orderTrueDriver.customRoutes.indexOf(route))),
        onDragenter: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dragEnter($event))),
        onDragleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dragLeave($event))),
        onDragover: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dragOver($event))),
        onDrop: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onDrop($event))),
        onDragend: _cache[4] || (_cache[4] = ($event: any) => (_ctx.dragEnd()))
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (index === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "col-1 m-0" }, null, -1)),
                    _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('drive_from')), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (index === this.store.state.orderTrueDriver.customRoutes.length - 1 && this.store.state.orderTrueDriver.customRoutes.length > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "col-1 m-0" }, null, -1)),
                    _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('drive_to')), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                (index === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, _cache[10] || (_cache[10] = [
                      _createElementVNode("img", {
                        src: "/assets/images/frame-arrow.svg",
                        alt: "arrow"
                      }, null, -1)
                    ])))
                  : (index === this.store.state.orderTrueDriver.customRoutes.length - 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, _cache[11] || (_cache[11] = [
                        _createElementVNode("img", {
                          src: "/assets/images/frame-flag.svg",
                          alt: "flag"
                        }, null, -1)
                      ])))
                    : (_openBlock(), _createElementBlock("div", _hoisted_14, _cache[12] || (_cache[12] = [
                        _createElementVNode("div", { class: "dots-img" }, null, -1)
                      ]))),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_CustomRouteAddressSelectComponent, {
                    "place-holder": index === 0 ? _ctx.$t('enter_pickup_address') : _ctx.$t('enter_destination_address'),
                    id: route.id,
                    "location-store": route.routePoint,
                    "arrival-time": route.arrivalTime,
                    isRemovable: _ctx.isRouteRemovable(index),
                    index: _ctx.firstIndex(index),
                    onGetAddresses: _ctx.getAddresses,
                    onDeleteRoute: _ctx.deleteRoute,
                    onGetArrivalTime: _ctx.getCustomArrivalTime
                  }, null, 8, ["place-holder", "id", "location-store", "arrival-time", "isRemovable", "index", "onGetAddresses", "onDeleteRoute", "onGetArrivalTime"])
                ])
              ])
            ])
          ])
        ])
      ], 40, _hoisted_1))
    }), 128)),
    (this.counter < _ctx.maxPoints)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", {
              class: "add-route-main-container",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addRouteInput(_ctx.maxPoints)))
            }, [
              _createElementVNode("div", _hoisted_18, [
                _cache[13] || (_cache[13] = _createElementVNode("div", {
                  class: "col-1 pe-0",
                  style: {"padding-left":"7px"}
                }, [
                  _createElementVNode("div", { class: "add-route" })
                ], -1)),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('add_one_more')), 1)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_21, [
      (!_ctx.messagesValidCustomRouteForm.validRoutes.state)
        ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.$t(_ctx.messagesValidCustomRouteForm.validRoutes.message)), 1))
        : _createCommentVNode("", true),
      (_ctx.message.state)
        ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.$t(_ctx.message.msg)), 1))
        : _createCommentVNode("", true)
    ]),
    _cache[18] || (_cache[18] = _createElementVNode("div", { class: "row" }, [
      _createElementVNode("div", { class: "col-1 m-0" }),
      _createElementVNode("div", { class: "col-11 input-col-10-padding" }, [
        _createElementVNode("div", {
          class: "hr-line",
          style: {"margin-top":"28px","margin-bottom":"24px"}
        })
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_24, [
      (!_ctx.messagesValidCustomRouteForm.validSelectedVehicle.state)
        ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.$t(_ctx.CustomRouteFormTemplateComponentErrorMessages.MESSAGE_SELECTED_VEHICLE)), 1))
        : _createCommentVNode("", true),
      _cache[14] || (_cache[14] = _createElementVNode("div", { class: "col-1 m-0" }, null, -1)),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("input", {
          class: "vehicle-picker-input",
          id: "",
          placeholder: _ctx.$t('please_select_vehicle'),
          value: _ctx.selectedVehicleValue
        }, null, 8, _hoisted_27)
      ])
    ]),
    _createElementVNode("div", _hoisted_28, [
      (!_ctx.messagesValidCustomRouteForm.validTravelObjective.state)
        ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.$t(_ctx.messagesValidCustomRouteForm.validTravelObjective.message)), 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_OptionSelectComponent, {
      placeholder: _ctx.$t('select_travel_objective'),
      data: this.store.state.orderTrueDriverTravelObjectives.travelObjectives,
      selected: _ctx.selectedTravelObjective,
      "onUpdate:selected": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedTravelObjective) = $event))
    }, null, 8, ["placeholder", "data", "selected"]),
    _createVNode(_component_CalendarComponent, {
      "is-valid": _ctx.messagesValidCustomRouteForm.validSelectedPredefinedOption
    }, null, 8, ["is-valid"]),
    _createElementVNode("div", _hoisted_30, [
      _cache[15] || (_cache[15] = _createElementVNode("div", { class: "col-1 m-0" }, null, -1)),
      _createElementVNode("div", _hoisted_31, [
        _createVNode(_component_CustomRoutePriceWrapperComponent, {
          "total-distance": _ctx.totalDistance,
          "total-duration": _ctx.totalDuration,
          price: _ctx.price
        }, null, 8, ["total-distance", "total-duration", "price"])
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      (!_ctx.store.state.orderTrueDriver.isValidCustomRouteForm)
        ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.$t(_ctx.CustomRouteFormTemplateComponentErrorMessages.MESSAGE_CUSTOM_ROUTE_FORM)), 1))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.backendValidationErrors, (error) => {
        return (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(_ctx.$t(error)), 1))
      }), 256))
    ]),
    _createElementVNode("div", _hoisted_35, [
      _cache[17] || (_cache[17] = _createElementVNode("div", { class: "col-1 m-0" }, null, -1)),
      _createElementVNode("div", _hoisted_36, [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_ButtonComponent, {
              key: 0,
              class: "order-form-submit-button m-0 w-100 mt-3"
            }, {
              btnContent: _withCtx(() => _cache[16] || (_cache[16] = [
                _createElementVNode("span", { class: "loader" }, null, -1)
              ])),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_ButtonComponent, {
              key: 1,
              class: _normalizeClass(["m-0 w-100 mt-3", {'disabled-button' : _ctx.disabledButton, 'order-form-submit-button' : !_ctx.disabledButton}]),
              disabled: _ctx.disabledButton,
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onSubmit($event)))
            }, {
              btnContent: _withCtx(() => [
                _createTextVNode(_toDisplayString(!_ctx.isOrderable ? _ctx.$t('calculate') : _ctx.$t('order_now')), 1)
              ]),
              _: 1
            }, 8, ["disabled", "class"]))
      ])
    ])
  ]))
}